import { useEffect } from 'react';
import styles from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function ProductAnimation() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.ProductAnimation');
    let innerHeight = 1080;

    if (typeof window !== 'undefined') {
        innerHeight = window?.innerHeight;
    }

    useEffect(() => {
        const AniContainer = window?.AniContainer;

        AniContainer.create({
            syncFromTo: [['.product-animation .bg-img', { scale: 1.5 }, { scale: 1 }]],
            triggerElement: '.product-animation',
            triggerHook: 1,
            offset: '100%',
            duration: '50%',
            scrollUpdatePos: true,
        });
        AniContainer.create({
            syncFromTo: [['.product-animation .mask', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.product-animation',
            triggerHook: 1,
            offset: '200%',
            duration: '50%',
            scrollUpdatePos: true,
        });
        AniContainer.create({
            syncFromTo: [['.product-animation .title-box', { opacity: 0, y: 40 }, { opacity: 1, y: 0 }]],
            triggerElement: '.product-animation',
            triggerHook: 1,
            offset: '200%',
            duration: '50%',
            scrollUpdatePos: true,
        });
    }, []);

    return (
        <div className={`${styles.productAnimation} product-animation`} style={{ height: innerHeight * 3 }}>
            <div className="sticky">
                <div className="img-box">
                    <div className="bg-img">
                        <NextImage
                            src="https://ecoflow-service-eu-prod.oss-eu-central-1.aliyuncs.com/upload/image/1713753545447/realiability_bg.jpg"
                            alt={t('title')}
                        />
                    </div>
                    <div className="mask" />
                    <div className="title-box">
                        <h2 className="title">{t('title')}</h2>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
